import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgConnectedCable = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m9.352 9.33 1.624-1.625a3.755 3.755 0 1 1 5.311 5.311l-1.625 1.625M16.291 7.7l4.7-4.7M14.649 14.67l-1.625 1.625a3.755 3.755 0 0 1-5.31-5.31l1.624-1.626M15.286 15.287 8.714 8.715M7.71 16.3 3.01 21M19.003 14.3l1.473.396M3.51 9.164l1.474.395M14.163 19.004l.54 1.426M9.285 3.43l.54 1.426"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgConnectedCable);
export default ForwardRef;
